(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-accordion-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var panels, dots, active = 0, timer;
  var DURATION = 4000;
  function init() {
    panels = document.querySelectorAll('#b2b-acc-hero .b2a-panel');
    var dotsEl = document.getElementById('b2b-acc-dots');
    if (!panels.length || !dotsEl) return;
    panels.forEach(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'b2b-acc-dot' + (i === 0 ? ' active' : '');
      d.addEventListener('click', function () { goTo(i); });
      dotsEl.appendChild(d);
    });
    dots = dotsEl.querySelectorAll('.b2b-acc-dot');
    panels.forEach(function (p, i) { p.addEventListener('click', function () { if (i !== active) goTo(i); }); });
    goTo(0);
  }
  function goTo(idx) {
    clearTimeout(timer);
    panels.forEach(function (p) { p.classList.remove('b2a-active', 'b2a-counting'); });
    if (dots) dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
    active = idx;
    panels[active].classList.add('b2a-active');
    void panels[active].offsetWidth;
    panels[active].classList.add('b2a-counting');
    timer = setTimeout(function () { goTo((active + 1) % panels.length); }, DURATION);
  }
  document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["branding-process"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ioS = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.querySelectorAll('.stagger-item').forEach(function (item, i) {
          setTimeout(function () { item.classList.add('in'); }, i * 100);
        });
        ioS.unobserve(entry.target);
      }
    });
  }, { threshold: 0.06 });
  var steps = document.querySelector('.cl-how-steps');
  if (steps) ioS.observe(steps);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  var grid = document.getElementById('bundle-grid');
  if (!grid) return;
  var MOQ = parseInt(grid.dataset.moq, 10) || 9;
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.bprod-card'));
  var qtys = {};

  var bpFill = document.getElementById('bp-fill');
  var bpCurrent = document.getElementById('bp-current');
  var bpStatus = document.getElementById('bp-status');
  var bsCount = document.getElementById('bs-count');
  var bsEmpty = document.getElementById('bs-empty');
  var bsItems = document.getElementById('bs-items');
  var bsTotal = document.getElementById('bs-total');
  var bsTotalAmount = document.getElementById('bs-total-amount');
  var bsPlaceBtn = document.getElementById('bs-place-btn');
  var bsPlaceBtnLabel = document.getElementById('bs-place-btn-label');
  var bsHint = document.getElementById('bs-hint');
  var bsRemaining = document.getElementById('bs-remaining');
  var bmcCount = document.getElementById('bmc-count');
  var bmcTotal = document.getElementById('bmc-total');
  var bmcBtn = document.getElementById('bmc-btn');

  function money(cents) { return '₹' + Math.round(cents / 100).toLocaleString('en-IN'); }

  function totalQty() { return Object.keys(qtys).reduce(function (s, k) { return s + qtys[k].qty; }, 0); }
  function totalPrice() { return Object.keys(qtys).reduce(function (s, k) { return s + qtys[k].qty * qtys[k].price; }, 0); }

  function render() {
    var count = totalQty();
    var total = totalPrice();
    var pct = Math.min(100, (count / MOQ) * 100);

    bpFill.style.width = pct + '%';
    bpCurrent.textContent = count;
    bsCount.textContent = count + ' / ' + MOQ + ' pcs';
    bmcCount.textContent = count + ' / ' + MOQ + ' pieces';
    bmcTotal.textContent = money(total);

    bpStatus.className = 'bp-status ' + (count === 0 ? 'empty' : count < MOQ ? 'partial' : count === MOQ ? 'ready' : 'over');
    bpStatus.textContent = count === 0 ? 'Pick designs ↓' : count < MOQ ? (MOQ - count) + ' more to go' : count === MOQ ? 'Ready to order!' : 'Remove ' + (count - MOQ) + ' to continue';

    var keys = Object.keys(qtys).filter(function (k) { return qtys[k].qty > 0; });
    if (keys.length === 0) {
      bsEmpty.style.display = '';
      bsItems.innerHTML = '';
      bsTotal.style.display = 'none';
    } else {
      bsEmpty.style.display = 'none';
      bsTotal.style.display = 'flex';
      bsTotalAmount.textContent = money(total);
      bsItems.innerHTML = keys.map(function (k) {
        var it = qtys[k];
        return '<div class="bs-item"><div class="bs-item-info"><div class="bs-item-name">' + it.name + '</div><div class="bs-item-qty">' + it.qty + ' pcs × ' + money(it.price) + '</div></div><div class="bs-item-price">' + money(it.qty * it.price) + '</div></div>';
      }).join('');
    }

    var ready = count === MOQ;
    var over = count > MOQ;
    bsPlaceBtn.disabled = !ready;
    bmcBtn.disabled = !ready;
    bsPlaceBtn.classList.toggle('ready', ready);
    bsPlaceBtnLabel.textContent = ready ? 'Place Order — ' + MOQ + ' pcs' : over ? 'Remove pieces to continue' : 'Select ' + MOQ + ' pieces to continue';
    bsHint.style.display = ready ? 'none' : '';
    bsRemaining.textContent = Math.abs(MOQ - count);

    cards.forEach(function (card) {
      var id = card.dataset.variantId;
      var qty = (qtys[id] && qtys[id].qty) || 0;
      card.querySelector('.bprod-step-num').textContent = qty;
      card.classList.toggle('selected', qty > 0);
      card.querySelector('.bprod-stepper').classList.toggle('active', qty > 0);
      card.querySelector('[data-action="minus"]').disabled = qty === 0;
    });
  }

  cards.forEach(function (card) {
    var id = card.dataset.variantId;
    var name = card.dataset.name;
    var price = parseInt(card.dataset.price, 10);
    card.querySelectorAll('.bprod-step-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtys[id]) qtys[id] = { qty: 0, name: name, price: price };
        if (btn.dataset.action === 'plus') qtys[id].qty++;
        else qtys[id].qty = Math.max(0, qtys[id].qty - 1);
        render();
      });
    });
  });

  function placeOrder() {
    var items = Object.keys(qtys).filter(function (k) { return qtys[k].qty > 0; }).map(function (k) {
      return { id: parseInt(k, 10), quantity: qtys[k].qty };
    });
    if (!items.length) return;
    var addUrl = (document.body && document.body.dataset.cartAddUrl) || '/cart/add.js';
    var cartUrl = (document.body && document.body.dataset.cartUrl) || '/cart';
    [bsPlaceBtn, bmcBtn].forEach(function (b) { b.disabled = true; b.textContent = 'Adding…'; });
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); }).then(function () {
      window.location.href = cartUrl;
    }).catch(function () {
      [bsPlaceBtn, bmcBtn].forEach(function (b) { b.disabled = false; });
      bsPlaceBtnLabel.textContent = 'Something went wrong — try again';
    });
  }
  bsPlaceBtn.addEventListener('click', placeOrder);
  bmcBtn.addEventListener('click', placeOrder);

  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["franchise-calculator-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sizeEl = document.getElementById('calc-size');
  var invEl = document.getElementById('calc-inv');
  var invValEl = document.getElementById('calc-inv-val');
  var footfallEl = document.getElementById('calc-footfall');
  var runBtn = document.getElementById('calc-run');
  var resultBox = document.getElementById('calc-result-box');
  if (!runBtn) return;

  function updateSliderTrack() {
    var pct = ((invEl.value - 5) / 20 * 100).toFixed(1) + '%';
    invEl.style.setProperty('--pct', pct);
    invValEl.textContent = invEl.value;
  }
  invEl.addEventListener('input', updateSliderTrack);
  updateSliderTrack();

  function money(v) {
    return v >= 100000 ? '₹' + (v / 100000).toFixed(1) + 'L' : '₹' + Math.round(v).toLocaleString('en-IN');
  }

  function countUp(el, target, suffix) {
    var start = performance.now();
    var dur = 1200;
    function tick(now) {
      var p = Math.min((now - start) / dur, 1);
      var e = 1 - Math.pow(1 - p, 4);
      var val = Math.floor(e * target);
      el.textContent = (suffix ? val.toLocaleString('en-IN') + suffix : money(val));
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  runBtn.addEventListener('click', function () {
    var inv = parseInt(invEl.value, 10);
    var sizeFactor = parseFloat(sizeEl.value);
    var footfallFactor = parseFloat(footfallEl.value);
    var revenue = Math.round(inv * 1.2 * sizeFactor * footfallFactor) * 10000;
    var profit = Math.round(revenue * 0.30);
    var payback = Math.ceil((inv * 100000) / profit);

    resultBox.style.display = '';
    countUp(document.getElementById('calc-out-revenue'), revenue);
    countUp(document.getElementById('calc-out-profit'), profit);
    countUp(document.getElementById('calc-out-payback'), payback, ' mo');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["franchise-map-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var hero = document.getElementById('flm-hero');
  var right = document.getElementById('flm-right');
  if (!hero) return;

  document.querySelectorAll('.flm-card').forEach(function (card) {
    var ci = card.querySelector('.flm-ci');
    if (!ci) return;
    var mx = 0, my = 0, tx = 0, ty = 0, raf;
    function lerp(a, b, t) { return a + (b - a) * t; }
    function tick() {
      tx = lerp(tx, mx, .1); ty = lerp(ty, my, .1);
      ci.style.transform = 'perspective(500px) rotateX(' + ty + 'deg) rotateY(' + tx + 'deg)';
      if (Math.abs(tx - mx) > .01 || Math.abs(ty - my) > .01) raf = requestAnimationFrame(tick);
    }
    card.addEventListener('mousemove', function (e) {
      var r = ci.getBoundingClientRect();
      mx = (e.clientX - r.left - r.width / 2) / (r.width / 2) * 7;
      my = -((e.clientY - r.top - r.height / 2) / (r.height / 2) * 7);
      cancelAnimationFrame(raf); raf = requestAnimationFrame(tick);
    });
    card.addEventListener('mouseleave', function () { mx = 0; my = 0; cancelAnimationFrame(raf); raf = requestAnimationFrame(tick); });
  });

  var cards = document.querySelectorAll('.flm-card');
  function ctr(el) {
    var hr = right ? right.getBoundingClientRect() : hero.getBoundingClientRect();
    var cr = el.getBoundingClientRect();
    return { x: cr.left - hr.left + cr.width / 2, y: cr.top - hr.top + cr.height / 2 };
  }

  var lines = document.querySelectorAll('.flm-ln');
  function updateLines() {
    lines.forEach(function (l, i) {
      var c1 = cards[i], c2 = cards[i + 1];
      if (!c1 || !c2) return;
      var p1 = ctr(c1), p2 = ctr(c2);
      l.setAttribute('x1', p1.x); l.setAttribute('y1', p1.y);
      l.setAttribute('x2', p2.x); l.setAttribute('y2', p2.y);
    });
  }

  var t0 = null;
  function animFrame(ts) {
    requestAnimationFrame(animFrame);
    if (!t0) t0 = ts;
    var e = (ts - t0) * .00035;
    updateLines();
    var dot = document.getElementById('fpd1');
    var ln = lines[0];
    if (dot && ln && ln.classList.contains('show')) {
      var ph = e % 1;
      var x1 = parseFloat(ln.getAttribute('x1')), y1 = parseFloat(ln.getAttribute('y1'));
      var x2 = parseFloat(ln.getAttribute('x2')), y2 = parseFloat(ln.getAttribute('y2'));
      dot.setAttribute('cx', x1 + (x2 - x1) * ph);
      dot.setAttribute('cy', y1 + (y2 - y1) * ph);
      dot.classList.add('show');
    }
  }
  requestAnimationFrame(animFrame);

  cards.forEach(function (c, i) { setTimeout(function () { c.classList.add('show'); }, 250 + i * 250); });
  setTimeout(function () {
    lines.forEach(function (l, i) { setTimeout(function () { l.classList.add('show'); }, i * 150); });
  }, 250 + cards.length * 250 + 200);
  setTimeout(function () { var l = document.getElementById('flm-left'); if (l) l.classList.add('show'); }, 300);

  window.addEventListener('resize', updateLines);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-categories"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.gh-cat-card').forEach(function (card) {
    var raf;
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width - 0.5) * 10;
      var y = ((e.clientY - r.top) / r.height - 0.5) * 10;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        card.style.transform = 'translateY(-8px) scale(1.02) perspective(600px) rotateX(' + (-y) + 'deg) rotateY(' + x + 'deg)';
      });
    });
    card.addEventListener('mouseleave', function () { cancelAnimationFrame(raf); card.style.transform = ''; });
  });

  var ioS = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.querySelectorAll('.stagger-item').forEach(function (item, i) {
          setTimeout(function () { item.classList.add('in'); }, i * 110);
        });
        ioS.unobserve(entry.target);
      }
    });
  }, { threshold: 0.06 });
  var grid = document.querySelector('.gh-cats-grid');
  if (grid) ioS.observe(grid);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-contents"] && !Shopify.designMode) return;
  try {
    
(function () {
  var track = document.getElementById('gh-carousel-track');
  var dotsEl = document.getElementById('gh-carousel-dots');
  if (!track || !dotsEl) return;
  var slides = track.children.length;
  var cur = 0, timer;
  if (!slides) return;

  for (var i = 0; i < slides; i++) {
    var d = document.createElement('button');
    d.type = 'button';
    d.className = 'gh-carousel-dot' + (i === 0 ? ' active' : '');
    d.dataset.i = i;
    dotsEl.appendChild(d);
  }

  function goTo(n) {
    cur = (n + slides) % slides;
    track.style.transform = 'translateX(-' + (cur * 100) + '%)';
    dotsEl.querySelectorAll('.gh-carousel-dot').forEach(function (d, j) { d.classList.toggle('active', j === cur); });
  }
  function startTimer() { clearInterval(timer); timer = setInterval(function () { goTo(cur + 1); }, 3500); }

  document.getElementById('gh-carousel-prev').addEventListener('click', function () { goTo(cur - 1); startTimer(); });
  document.getElementById('gh-carousel-next').addEventListener('click', function () { goTo(cur + 1); startTimer(); });
  dotsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('.gh-carousel-dot');
    if (btn) { goTo(parseInt(btn.dataset.i, 10)); startTimer(); }
  });
  track.parentElement.addEventListener('mouseenter', function () { clearInterval(timer); });
  track.parentElement.addEventListener('mouseleave', startTimer);
  startTimer();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-customisation"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ioS = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.querySelectorAll('.stagger-item').forEach(function (item, i) {
          setTimeout(function () { item.classList.add('in'); }, i * 100);
        });
        ioS.unobserve(entry.target);
      }
    });
  }, { threshold: 0.06 });
  var grid = document.querySelector('.gh-custom-grid');
  if (grid) ioS.observe(grid);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wrap = document.getElementById('hero-cycle-wrap');
  if (wrap) {
    var words = (wrap.dataset.words || '').split('|').filter(Boolean);
    var ci = 0;
    if (words.length > 1) {
      setInterval(function () {
        var old = wrap.querySelector('.current');
        if (old) { old.classList.replace('current', 'exit'); setTimeout(function () { if (old.parentNode) old.parentNode.removeChild(old); }, 400); }
        ci = (ci + 1) % words.length;
        var next = document.createElement('span');
        next.className = 'cycle-word enter';
        next.textContent = words[ci];
        wrap.appendChild(next);
        setTimeout(function () { next.classList.remove('enter'); next.classList.add('current'); }, 20);
      }, 2400);
    }
  }

  var dotsEl, dotEls;
  function initDots() {
    dotsEl = document.getElementById('stack-dots');
    dotEls = dotsEl ? Array.prototype.slice.call(dotsEl.querySelectorAll('.sdot')) : [];
  }
  function updateDots() {
    if (!dotsEl) return;
    var vh = window.innerHeight;
    var sy = window.scrollY;
    var inStack = sy > 30 && sy < vh * 2.1;
    dotsEl.classList.toggle('visible', inStack);
    if (!inStack) return;
    var idx = Math.min(1, Math.floor(sy / (vh * 0.9)));
    dotEls.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
    dotsEl.classList.toggle('on-white', idx === 1);
  }
  initDots();
  updateDots();
  window.addEventListener('scroll', updateDots, { passive: true });

  var s1, _cRaf;
  function onScroll() {
    if (window.innerWidth <= 768) return;
    if (_cRaf) return;
    _cRaf = requestAnimationFrame(function () {
      _cRaf = null;
      if (!s1) { s1 = document.querySelector('.stack-s1'); }
      var vh = window.innerHeight;
      var sy = window.scrollY;
      var p1 = Math.max(0, Math.min(1, (sy - vh * 0.5) / (vh * 0.7)));
      if (s1) s1.style.transform = p1 > 0 ? 'scale(' + (1 - p1 * 0.055).toFixed(4) + ') translateY(-' + (p1 * 1.5).toFixed(2) + '%)' : '';
    });
  }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var grid = document.getElementById('ig-live-grid');
      if (!grid) return;
      var feedUrl = grid.dataset.igFeed;
      if (!feedUrl) return;
      var profileUrl = grid.dataset.igProfile;
      var tiles = grid.querySelectorAll('.ig-tile');

      fetch(feedUrl)
        .then(function (res) { return res.ok ? res.json() : Promise.reject(res.status); })
        .then(function (photos) {
          if (!Array.isArray(photos) || !photos.length) return;
          tiles.forEach(function (tile, i) {
            var photo = photos[i % photos.length];
            if (!photo || !photo.image) return;
            tile.href = photo.permalink || profileUrl || tile.href;
            tile.innerHTML = '<img src="' + photo.image + '" alt="' + (photo.caption ? photo.caption.replace(/"/g, '&quot;').slice(0, 140) : 'Instagram photo') + '" width="500" height="500" loading="lazy" style="width:100%;height:100%;object-fit:cover">' +
              '<div class="ig-tile-overlay">♥</div>';
          });
        })
        .catch(function () {
          /* leave the static fallback tiles in place */
        });
    })();
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["label-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  var TYPES = {
    embroidery: { sub: 'EMBROIDERED LABEL' },
    woven: { sub: 'WOVEN LABEL' },
    printed: { sub: 'PRINTED LABEL' },
    hangtag: { sub: 'HANG TAG' }
  };
  var activeType = 'embroidery';
  var brandInput = document.getElementById('brand-input');
  var taglineInput = document.getElementById('tagline-input');
  var preview = document.getElementById('label-preview');
  var labelName = document.getElementById('label-name');
  var labelTagline = document.getElementById('label-tagline');
  var labelTypeSub = document.getElementById('label-type-sub');
  if (!brandInput || !preview) return;

  function updatePreview() {
    var name = brandInput.value.trim().toUpperCase() || 'YOUR BRAND';
    var tagline = taglineInput.value.trim().toUpperCase() || 'QUALITY HOME LINEN';
    labelName.textContent = name;
    labelTagline.textContent = tagline;
    labelTypeSub.textContent = TYPES[activeType].sub;
    preview.className = 'cl-label-realistic ' + activeType;
    preview.style.transform = 'scale(0.93) rotate(-1.5deg)';
    requestAnimationFrame(function () { requestAnimationFrame(function () { preview.style.transform = ''; }); });
  }

  brandInput.addEventListener('input', updatePreview);
  taglineInput.addEventListener('input', updatePreview);

  document.querySelectorAll('.cl-type-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.cl-type-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      activeType = btn.dataset.type;
      updatePreview();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["label-types-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.cl-type-card').forEach(function (card) {
    var raf;
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width - 0.5) * 12;
      var y = ((e.clientY - r.top) / r.height - 0.5) * 12;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        card.style.transform = 'translateY(-7px) perspective(600px) rotateX(' + (-y) + 'deg) rotateY(' + x + 'deg)';
      });
    });
    card.addEventListener('mouseleave', function () { cancelAnimationFrame(raf); card.style.transform = ''; });
  });

  var ioS = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.querySelectorAll('.stagger-item').forEach(function (item, i) {
          setTimeout(function () { item.classList.add('in'); }, i * 100);
        });
        ioS.unobserve(entry.target);
      }
    });
  }, { threshold: 0.06 });
  var grid = document.querySelector('.cl-types-grid');
  if (grid) ioS.observe(grid);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  function syncHidden(display) {
    var line = display.dataset.line;
    var piecesPerUnit = parseInt(display.dataset.piecesPerUnit, 10) || 1;
    var hidden = document.querySelector('.cart-qty-input[data-line="' + line + '"]');
    if (!hidden) return;
    var pieces = parseInt(display.value, 10) || 0;
    var snapped = Math.round(pieces / piecesPerUnit) * piecesPerUnit;
    display.value = snapped;
    hidden.value = snapped / piecesPerUnit;
  }

  document.querySelectorAll('.cart-qty-minus, .cart-qty-plus').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var display = document.querySelector('.cart-qty-display[data-line="' + btn.dataset.line + '"]');
      if (!display) return;
      var piecesPerUnit = parseInt(display.dataset.piecesPerUnit, 10) || 1;
      var val = parseInt(display.value, 10) || 0;
      val = btn.classList.contains('cart-qty-plus') ? val + piecesPerUnit : Math.max(0, val - piecesPerUnit);
      display.value = val;
      syncHidden(display);
    });
  });

  document.querySelectorAll('.cart-qty-display').forEach(function (input) {
    input.addEventListener('change', function () { syncHidden(input); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var el = document.querySelector('.pdp-related[data-url]');
  if (!el) return;
  fetch(el.dataset.url)
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.pdp-related');
      if (fresh && fresh.querySelector('.pdr-card')) {
        el.outerHTML = fresh.outerHTML;
      } else {
        el.remove();
      }
    })
    .catch(function () { el.remove(); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resell-typewriter-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var el = document.getElementById('tw-typed');
  if (!el) return;
  var TEXTS = (el.dataset.phrases || '').split('|').filter(Boolean);
  if (!TEXTS.length) return;
  var ti = 0, ci = 0, deleting = false;
  function tick() {
    var full = TEXTS[ti];
    if (!deleting) {
      ci++; el.textContent = full.slice(0, ci);
      if (ci === full.length) { deleting = true; setTimeout(tick, 2200); return; }
      setTimeout(tick, 115);
    } else {
      ci--; el.textContent = full.slice(0, ci);
      if (ci === 0) { deleting = false; ti = (ti + 1) % TEXTS.length; setTimeout(tick, 400); return; }
      setTimeout(tick, 65);
    }
  }
  document.addEventListener('DOMContentLoaded', function () { setTimeout(tick, 800); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  function embedUrlFor(url) {
    if (!url) return null;
    var yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
    if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0';
    var vm = url.match(/vimeo\.com\/(\d+)/);
    if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
    return null;
  }
  function openLightbox(embedUrl) {
    var lb = document.getElementById('video-lightbox');
    if (!lb) return;
    lb.querySelector('.video-lightbox-frame').innerHTML = '<iframe src="' + embedUrl + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    lb.classList.add('open');
    lb.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    var lb = document.getElementById('video-lightbox');
    if (!lb) return;
    lb.classList.remove('open');
    lb.setAttribute('aria-hidden', 'true');
    lb.querySelector('.video-lightbox-frame').innerHTML = '';
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.video-thumb[data-video-url]');
    if (thumb) {
      var embed = embedUrlFor(thumb.dataset.videoUrl);
      if (embed) { e.preventDefault(); openLightbox(embed); }
      return;
    }
    if (e.target.closest('[data-lightbox-close]')) closeLightbox();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLightbox(); });
})();

  } catch(e) { console.error(e); }
})();
})();
